export default __webpack_public_path__ + "static/media/GB-SCT.ff64e329.svg";